import router from "@/router"
import store from "@/store"

class Router {
  push(route) {
    try {
      if (typeof route !== "string" && typeof route !== "object") return _$.log("Undefined route", false)

      let res
      if (typeof route === "object") res = this.validateAsObject(route)
      else res = this.validateAsPath(route)

      if (res === "platform") return true
      else if (typeof res !== "object") return false

      router.push(res.path).catch(err => _$.error(err))

      return true
    } catch (err) {
      return _$.error(err)
    }
  }
  isSame(route) {
    try {
      if (typeof route !== "string" && typeof route !== "object") return _$.log("Undefined route", false)

      if (typeof route === "object") this.validateAsObject(route, false)
      else this.validateAsPath(route)

      return false
    } catch (err) {
      if (err === "Same route.") return true
      else return _$.error(err)
    }
  }
  validateAsObject(object, platformCheck = true) {
    if (!object.hasOwnProperty("name")) throw "Name property is missing."

    if (platformCheck && ["apps", "app", "source", "sources", "system", "sideload"].indexOf(object.name) >= 0) return this.resolveForPlatform(object)

    const res = router.resolve({ ...object })
    if (!res.resolved.matched.length) throw "Not found."
    if (router.currentRoute.name && router.currentRoute.path === res.resolved.path) throw "Same route."

    if (platformCheck && res.resolved.name === "live" && !store.state.live.channels) return _$.error("The platform has no channels")
    return { path: res.resolved.path }
  }
  validateAsPath(path) {
    if (path === "") path = "/"
    if (!path.startsWith("/")) path = "/" + path

    path = path.toLowerCase()

    const res = router.resolve(path)
    if (!res.resolved.matched.length) throw "Not found."
    if (router.currentRoute.name && router.currentRoute.path === res.resolved.path) throw "Same route."

    return { path: res.resolved.path }
  }
  resolveForPlatform(route) {
    switch (route.name) {
      case "app":
        __.app.launch(route.params.target).then(res => !res && __.app.syncAppList())
        break
      case "apps":
        __.app.select(route.title, route.params.target)
        break
      case "source":
        __.source.setByName(route.params.target)
        break
      case "sources":
        __.source.select()
        break
      case "weather":
        __.app.launch("weather", route.params.target)
        break
      case "system":
        _$.vue.$emit("worker", route.params.target)
        break
      case "sideload":
        _$.vue.$sideload(route.params.target, "right")
        break

      default:
        break
    }
    return "platform"
  }
}

export default new Router()
